module.exports = __webpack_public_path__ + "static/media/creative-commons-pd.6a760fe7.svg";